<template>
  <div class="lien-constructeur encart">
    <h2 v-if="lien || isEditing">Lien vers le constructeur</h2>
    <h2 v-else class="h2-add" @click="startEditing">
      Ajouter un lien vers le constructeur
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
        <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
        <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
      </svg>
    </h2>

    <div v-if="!isEditing">
      <div v-if="lien" class="lien-row">
        <a :href="lien" target="_blank" rel="noopener noreferrer" class="lien-display">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
          </svg>
          {{ lien }}
        </a>
        <div class="lien-icons">
          <button class="icon-btn" title="Modifier" @click="startEditing">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
              <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
            </svg>
          </button>
          <button class="icon-btn icon-btn--delete" title="Supprimer" @click="deleteLien">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
              <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
            </svg>
          </button>
        </div>
      </div>


    </div>

    <div v-else class="lien-form">
      <div class="lien-input-row">
      <input
        v-model="lienEdit"
        type="url"
        placeholder="URL vers le constructeur"
        class="lien-input"
        @keyup.enter="save"
        @keyup.esc="cancelEditing"
      />
      <div class="lien-actions">
        <button class="icon-btn icon-btn--save" title="Enregistrer" @click="save" :disabled="isSaving">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
            <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
          </svg>
        </button>
        <button class="icon-btn" title="Annuler" @click="cancelEditing">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
          </svg>
        </button>
      </div>
      </div>
      <p v-if="errorMessage" class="lien-error">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';

export default {
  data() {
    return {
      codeArticle: null,
      lien: '',
      lienEdit: '',
      isEditing: false,
      isSaving: false,
      errorMessage: '',
    };
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;
    this.loadLien();
  },
  methods: {
    async loadLien() {
      try {
        const response = await axios.post('https://www.simef.fr/espace-client/api/getLienConstructeur.php', {
          codeArticle: this.codeArticle,
        });
        this.lien = response.data.lien_constructeur || '';
      } catch (error) {
        console.error('Erreur chargement lien constructeur:', error);
      }
    },
    startEditing() {
      this.lienEdit = this.lien;
      this.isEditing = true;
      this.errorMessage = '';
    },
    cancelEditing() {
      this.isEditing = false;
      this.lienEdit = '';
      this.errorMessage = '';
    },
    async save() {
      this.errorMessage = '';
      if (this.lienEdit && !this.lienEdit.startsWith('http')) {
        this.errorMessage = "L'URL doit commencer par http:// ou https://";
        return;
      }
      this.isSaving = true;
      try {
        await axios.post('https://www.simef.fr/espace-client/api/setLienConstructeur.php', {
          codeArticle: this.codeArticle,
          lien: this.lienEdit,
        });
        this.lien = this.lienEdit;
        this.isEditing = false;
      } catch (error) {
        this.errorMessage = "Erreur lors de l'enregistrement.";
        console.error(error);
      } finally {
        this.isSaving = false;
      }
    },
    async deleteLien() {
      if (!confirm('Supprimer le lien constructeur ?')) return;
      try {
        await axios.post('https://www.simef.fr/espace-client/api/setLienConstructeur.php', {
          codeArticle: this.codeArticle,
          lien: '',
        });
        this.lien = '';
      } catch (error) {
        console.error('Erreur suppression lien:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lien-constructeur {
  margin-top: 20px;
  padding: 20px;

  h2 {
    font-size: 1rem;
    margin-bottom: 12px;
    color: #1d1d20;
  }

  .lien-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .lien-empty-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .lien-display {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #2b358d;
    font-size: 0.85rem;
    word-break: break-all;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  .h2-add {
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
    margin-bottom: 0 !important;
    &:hover {
      opacity: 0.75;
    }
  }

  .lien-icons {
    display: flex;
    gap: 4px;
    flex-shrink: 0;
  }

  .icon-btn {
    appearance: none !important;
    -webkit-appearance: none !important;
    background: none !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
    padding: 0 !important;
    margin: 0 !important;
    color: #2b358d !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    &:hover { background: none !important; color: #2b358d !important; opacity: 0.65 !important; transform: none !important; box-shadow: none !important; }
    &:hover::before, &:hover::after { display: none !important; }
    &--delete { color: #dc3545 !important;
      &:hover { color: #dc3545 !important; }
    }
    &--save { color: #198754 !important;
      &:hover { color: #198754 !important; }
    }
    &:disabled { opacity: 0.4 !important; cursor: not-allowed !important; }
  }

  .lien-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .lien-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .lien-input {
    flex: 1;
    padding: 7px 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 0.85rem;
    &:focus {
      outline: none;
      border-color: #2b358d;
    }
  }

  .lien-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
  }

  .lien-error {
    color: #dc3545;
    font-size: 0.8rem;
    margin: 0;
  }
}
</style>
